module.exports = __webpack_public_path__ + "static/media/cropline_logo.08f1c459.png";